import { Form, Input, Modal } from 'antd'
import { t } from 'i18next'
import React from 'react'
import { MessageTemplate } from '../message-template'
import { MessageTemplateFormFields } from './message-template-form-fields'
import useForm from '../../hooks/use-form'
import { FormItem } from '../../components/form-item'
import { useStoreMessageTemplate } from '../message-template-hooks'

type MessageTemplateCreateModalProps = {
    open: boolean
    whatsappBusinessAccountId?: MessageTemplate['whatsappBusinessAccountId']
    purpose?: MessageTemplate['purpose']
    onCancel: () => void
}

export function MessageTemplateCreateModal({
    open,
    whatsappBusinessAccountId,
    purpose,
    onCancel,
}: MessageTemplateCreateModalProps) {
    const createTemplate = useStoreMessageTemplate()
    const formProps = useForm({
        mutation: createTemplate,
        onSuccess: () => {
            onCancel()
        },
    })

    return (
        <Modal
            title={t('Create template')}
            open={open}
            onCancel={onCancel}
            confirmLoading={createTemplate.isPending}
            onOk={() => {
                formProps.form.submit()
            }}
            afterOpenChange={(isOpen) => {
                if (!isOpen) {
                    formProps.form.resetFields()
                    return
                }
            }}
        >
            <Form
                {...formProps}
                initialValues={{
                    whatsappBusinessAccountId,
                    purpose: purpose ?? 'start',
                    body: 'Hi {{1}}, Heb je even tijd om te praten over {{2}}',
                }}
                layout="vertical"
            >
                <FormItem
                    name="whatsappBusinessAccountId"
                    noStyle
                >
                    <Input hidden />
                </FormItem>
                <MessageTemplateFormFields />
            </Form>
        </Modal>
    )
}
